import layoutDetail from '@/layouts/layout-detail.vue'

export default [
  {
    path: '/productList',
    redirect: '/productList',
    component: layoutDetail,
    /* hidden: true, */
    children: [{
      path: '/productList/:id',
      name: 'productList',
      component: resolve => require.ensure([], () => resolve(require('@/views/productList/index.vue')), 'productList'),
      meta: { title: '列表页', icon: '' }
    },
    {
      path: '/productList',
      name: 'productList',
      component: resolve => require.ensure([], () => resolve(require('@/views/productList/index.vue')), 'productList'),
      meta: { title: '列表页', icon: '' }
    }]
  }
]
